import { render } from "./UserModal3.vue?vue&type=template&id=7f2f3e57"
import script from "./UserModal3.vue?vue&type=script&lang=ts"
export * from "./UserModal3.vue?vue&type=script&lang=ts"

import "./UserModal3.vue?vue&type=style&index=0&id=7f2f3e57&lang=css"
script.render = render

export default script